module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel box-collapse border-color-skin",
    attrs: {
      "id": "hres7de-detail-tab2"
    }
  }, [_c('div', {
    staticClass: "box-header with-border box-header-collapse collapsed  tab-header",
    attrs: {
      "data-toggle": "collapse",
      "data-parent": "#accordion",
      "href": "#tab2"
    }
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_c('i', {
    staticClass: "fa fa-file-text-o margin-r-5 margin-r-5"
  }), _vm._v(_vm._s(_vm.labels['HRES7DEP2']['20']) + "\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "panel-collapse collapse tab-detail",
    attrs: {
      "id": "tab2"
    }
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-5 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7DEP2']['20']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-control readonly-field-color"
  }, [_vm._v(_vm._s(_vm.detailTab2.detail.codform) + " - " + _vm._s(_vm.detailTab2.detail.desc_codform))])])])]), _vm._v(" "), _c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group margin-b-5"
  }, [_c('label', {
    staticClass: "col-md-5 control-label"
  }, [_vm._v(_vm._s(_vm.labels['HRES7DEP2']['80']))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.detailTab2.detail.destrevl),
      expression: "detailTab2.detail.destrevl"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('max:100'),
      expression: "'max:100'"
    }],
    staticClass: "form-control textarea-text",
    attrs: {
      "maxlength": "100",
      "data-vv-name": "destrevl",
      "has-error": _vm.errors.has('destrevl')
    },
    domProps: {
      "value": (_vm.detailTab2.detail.destrevl)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detailTab2.detail, "destrevl", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('destrevl')),
      expression: "errors.has('destrevl')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('destrevl')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(100)))])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.save()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))])])]), _vm._v(" "), (_vm.detailTab2.table1.rows.length > 0) ? _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "col-md-12 clear-padding"
  }, [_c('div', {
    staticClass: "evaluation-wrapper"
  }, [_vm._l((_vm.detailTab2.table1.rows), function(dataGroup) {
    return [_c('group', {
      attrs: {
        "labels": _vm.labels,
        "dataGroup": dataGroup,
        "choices": _vm.detailTab2.table2.rows,
        "name": "tab2"
      }
    })]
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 clear-padding"
  }, [_c('div', {
    staticClass: "evaluation-sum"
  }, [_vm._v("\n            " + _vm._s(_vm.labels['HRES7DEP2']['70']) + " " + _vm._s(_vm.calResultScore(_vm.detailTab2.table1.rows)) + "/" + _vm._s(_vm.calTotalScore(_vm.detailTab2.table1.rows)) + "\n          ")])])]) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ad122d4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres7de/detailTab2.vue
// module id = 3536
// module chunks = 1